import { useInfiniteQuery } from 'react-query';

import client from '@/apis/aniftyBackend/client';
import useAccessToken from '@/hooks/useAccessToken';

import { Notification } from './interface';

export type GetNotificationParams = {
  limit?: number;
  offset?: number;
};

export const getNotifications = async ({
  limit,
  offset,
}: GetNotificationParams): Promise<Notification[]> => {
  const params = new URLSearchParams();

  params.append('limit', limit ? limit.toString() : '20');

  params.append('offset', offset ? offset.toString() : '0');

  const response = await client.get<Notification[]>('api/notifications', {
    params,
  });

  return response.data;
};

type UseNotificationsOptions = {
  itemsPerPage?: number;
};

export const useNotifications = ({
  itemsPerPage = 20,
}: UseNotificationsOptions) => {
  const { accessToken } = useAccessToken();

  return useInfiniteQuery<Notification[]>({
    enabled: !!accessToken,
    queryKey: ['notifications'],
    queryFn: ({ pageParam }) =>
      getNotifications({
        limit: itemsPerPage,
        offset: pageParam,
      }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < itemsPerPage) {
        return null;
      }

      return allPages.flat().length;
    },
    retry: 3,
  });
};
